import React from 'react';
import Communication from '../../images/communication.svg'
import Research from '../../images/research.svg'
import SelfManagement from '../../images/selfmanagement.svg'
import Social from '../../images/social.svg'
import Thinking from '../../images/thinking.svg'
import BadgeNone from '../../images/BadgeNone.png'
import BadgeBronze from '../../images/BadgeBronze.png'
import BadgeSilver from '../../images/BadgeSilver.png'
import BadgeGold from '../../images/BadgeGold.png'
import BadgeRuby from '../../images/BadgeRuby.png'
import trophy from '../../images/trophy.png'


const BadgeHeader = ({data, t, lng}) => {
  let img;
  switch (data.name) {
    case 'Communication':
      img = Communication
      break;
    case 'Research':
      img = Research
      break;
    case 'Self-Management':
      img = SelfManagement
      break;
    case 'Social':
      img = Social
      break;
    case 'Thinking':
      img = Thinking
      break;
  }

  let badge;
  switch (data.nextLevel) {
    case 'Bronze':
      badge = BadgeNone
      break;
    case 'Silver':
      badge = BadgeBronze
      break;
    case 'Gold':
      badge = BadgeSilver
      break;
    case 'Ruby':
      badge = BadgeGold
      break;
    default:
      badge = BadgeRuby
      break;
  }

return (
  <div style={{display: 'flex'}}>
    <div style={{height: 105 }}>
      <img style={{maxWidth: 80}} src={badge} />
      <img style={{maxWidth: 45, position: 'relative', bottom: 89, left: 19}} src={img} />
    </div>
    <div style={{paddingLeft: 20, width: '100%'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
        <div style={{display: 'inline-block'}}>
          <h5 style={{color: data.color, fontSize: 16, marginTop: 20, float: 'left' }}>{t(data.name)} {!isNaN(data.remaining) && 9-data.remaining+'/9'}</h5>
          {!data.nextLevel && <img src={trophy} style={{float: 'left', maxWidth: 20, height: 'auto', marginTop: 20, marginLeft: 10 }}/>}
        </div>
        <h5 style={{color: data.color, fontSize: 16, marginTop: 20 }}>{t(data.level)}</h5>
      </div>
      <p style={{color: '#CBCACB', fontSize: 16}}>
        {!data.nextLevel ?
          t('Congratulations you have completed the Ruby badge')
        :
          lng == 'EN'
            ? `Complete ${data.remaining} more for ${data.nextLevel} Badge`
            : `Terminez ${data.remaining} de plus pour le badge ${t(data.nextLevel)}.`

        }
      </p>
    </div>
  </div>
)};

export default BadgeHeader;



// WEBPACK FOOTER //
// ./src/components/Badges/BadgeHeader.jsx